<template>
  <ul class="cards-list">
    <li
      v-for="(card, i) in cards"
      :key="i"
      class="cards-list__item"
    >
      <ProductCardSmart
        :card="card"
        theme="secondary"
        class="cards-list__card"
        @click="emit('click:card', getCardData(card, i))"
        @visible="emit('visible:card', getCardData(card, i))"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
  import type { Card } from '@academica-box/components/Cards/UiProductCard/types'

  import ProductCardSmart from '@/components/ProductCard.smart/ProductCard.smart.vue'

  defineProps<{
    cards: Card[];
  }>()

  const emit = defineEmits([
    'click:card',
    'visible:card'
  ])

  const getCardData = (card: Card, index: number) => {
    return {
      ...card,
      nomenclatureType: card.isFree ? 'free' : 'paid',
      cardNumber: index + 1
    }
  }
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/combinations/media-reset-z' as *;

  .cards-list {
    @include ulres;

    display: grid;
    grid-gap: 32px 12px;
    grid-template-columns: 1fr 1fr;

    @include media(md, md-max) {
      grid-column-gap: 24px;
      grid-template-columns: repeat(3, 1fr);
    }

    @include media(lg) {
      grid-column-gap: 32px;
    }

    @include media(xxl) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .cards-list__item {
    position: relative;

    &::before {
      @include media(lg) {
        @include z-index(below);

        position: absolute;
        width: 100%;
        height: 100%;
        background-color: var(--bg-invert-color);
        opacity: 0.03;
        filter: blur(15px);
        content: "";
      }
    }
  }

  .cards-list__card {
    height: 100%;
  }
</style>
